import { Route } from 'react-router-dom';
import { home } from 'routes/config';

import Worksheet from 'containers/Business/Agent/Worksheet';
import WorksheetForm from 'containers/Business/Agent/Worksheet/Components/WorksheetForm';
import CreateColumnForm from 'containers/Business/Agent/Worksheet/Components/CreateColumnForm';
import WorkflowForm from 'containers/Business/Agent/Worksheet/Components/WorkflowForm';
import ImportCsvForm from 'containers/Business/Agent/Worksheet/Components/ImportCsvForm';

export const worksheetRoutes = (
  <Route path={home.worksheets} element={<Worksheet />}>
    <Route path='add' element={<WorksheetForm />} />
    <Route path='add-workflow' element={<WorkflowForm />} />
    <Route path='add-column' element={<CreateColumnForm />} />
    <Route path=':worksheetId/edit' element={<WorksheetForm />} />
    <Route path=':worksheetId/import-csv' element={<ImportCsvForm />} />
  </Route>
);
